import useBoniVisibility from 'containers/Boni/hooks/useBoniVisibility';
import { openInfoBoniModal } from 'containers/Boni/infoBoniModal';
import { Button, Flex, Icon } from 'front-commons/ds';
import { useResponsive } from 'front-commons/hooks';
import useViewPort from 'hooks/useViewPort';
import { Typography } from 'hype-ds';
import { getBasketProductsData } from 'pages/checkout/OrderRevision/helpers';
import { useEffect } from 'react';
import { BasketFullParams } from 'services/basket/interfaces';
import { onSeeMoreClick, seeBoniInfo } from 'shared/gtm';
import useDialog from 'stores/dialog';
import usePos from 'stores/pos';

interface BoniPointsProps {
	totalLiquid: number;
	finalTotalPrice: number;
	baskets: BasketFullParams[];
}

export function BoniPoints({ totalLiquid, finalTotalPrice, baskets }: BoniPointsProps) {
	const { formatPoints, levelConfig, cashbackPercentage, level, levelName, showBoniPoints } =
		useBoniVisibility(totalLiquid);
	const { small } = useResponsive();
	const { handleOpenDialog } = useDialog();
	const { isInViewPort, ref } = useViewPort({ once: true });

	if (!showBoniPoints) return null;
	const productsData = getBasketProductsData(baskets);

	const {
		posStore: { selectedPos },
	} = usePos();

	useEffect(() => {
		if (!isInViewPort) return;

		seeBoniInfo({
			page: 'cart',
			userType: selectedPos?.role,
			boniLevel: levelName,
			cartValue: finalTotalPrice,
			totalBoniPoints: formatPoints,
			basketProductsData: productsData,
		});
	}, [isInViewPort]);

	const handleSeeMore = () => {
		openInfoBoniModal({
			level,
			levelName,
			isMobile: small,
			levelConfig,
			cashbackPercentage,
			handleOpenDialog,
		});

		onSeeMoreClick({
			totalBoniPoints: formatPoints,
			cartValue: finalTotalPrice,
			boniLevel: levelName,
			basketProductsData: productsData,
		});
	};

	return (
		<div ref={ref}>
			<Flex direction="row" gap="4px" justifyContent="space-between" width="100%">
				<Flex direction="column" gap={{ small: '8px', medium: '0' }} width="100%">
					<Flex justifyContent="space-between" width="100%">
						<Flex gap="8px">
							<Typography.Label.M color="--boni-purple700">Pontos Boni</Typography.Label.M>
							<Button variant="none" color="--text-link" onClick={handleSeeMore}>
								Saiba mais
							</Button>
						</Flex>

						<Flex justifyContent="center" alignItems="center" gap="4px">
							<Icon name="boniLogo" size="20px" color="--boni-purple700" />

							<Typography.Label.L color="--boni-purple700">+ {formatPoints} pontos</Typography.Label.L>
						</Flex>
					</Flex>

					{level === 1 && (
						<Flex gap="4px" whiteSpace="nowrap">
							<Typography.Paragraph.XS color="--text-primary">
								A primeira compra faturada no Boni vale
							</Typography.Paragraph.XS>
							<Typography.Paragraph.XS color="--boni-purple700">+ 100 pontos.</Typography.Paragraph.XS>
						</Flex>
					)}
				</Flex>
			</Flex>
		</div>
	);
}
